(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-cn"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper(".swiper-container", {
    loop: false,
    slidesPerView: 2,
    slidesPerGroup: 2,
	speed: 1000,
    breakpoints: {
      768: {
        slidesPerView: 5,
        slidesPerGroup: 1,
      }
    },
    pagination: {
      el: ".djt_swiper-indicators",
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: ".djt_swiper-control-next",
      prevEl: ".djt_swiper-control-prev"
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper(".swiper-container", {
    loop: true,
    slidesPerView: 2,
    slidesPerGroup: 2,
	speed: 1000,
    breakpoints: {
      768: {
        slidesPerView: 5,
        slidesPerGroup: 1,
      }
    },
    pagination: {
      el: ".djt_swiper-indicators",
      type: 'bullets',
      clickable: true
    },
    navigation: {
      nextEl: ".djt_swiper-control-next",
      prevEl: ".djt_swiper-control-prev"
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-newsletter"] && !Shopify.designMode) return;
  try {
    
$(function(){
    $("input[type='checkbox']").on('change', function () {
        if ($(".djt_custom-control-input:checked").length > 1) {
		  $(".djt_pointer-events").removeClass("djt_btn-change");
        } else {
          $(".djt_pointer-events").addClass("djt_btn-change");
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customers-register"] && !Shopify.designMode) return;
  try {
    
            $('form').submit(function() {
                let NewsletterTag = 'newsletter';
				let MarketingTag = 'true'
                if ($('#form-checkbox-is-agree-newsletter').prop('checked') == true) {
                    $('#newsletter-is-agree').val(NewsletterTag);
					$('#shopify-mail-marketing-agree').val(MarketingTag);
                } else {
                    $('#newsletter-is-agree').val();
					$('#shopify-mail-marketing-agree').val();
                }
            });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-en"] && !Shopify.designMode) return;
  try {
    
$(function(){
    $("input[type='checkbox']").on('change', function () {
        if ($(".djt_custom-control-input:checked").length > 1) {
		  $(".djt_pointer-events").removeClass("djt_btn-change");
        } else {
          $(".djt_pointer-events").addClass("djt_btn-change");
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
